import { PostcardActionAttributes } from "../Post.types";
import {
    ButtonsContainer,
    QuickActionsContainer,
} from "./PostActionButtons.styles";
import { LocationButton } from "./LocationButton";
import { PostActionButtonsCommentsAndReactions } from "./PostActionButtonsCommentsAndReactions";
import { PostPollStats } from "./PostPollStats";

export function PostActionButtons(props: PostcardActionAttributes) {
    const { pollsOptions, postId, showPollStats = true } = props;

    return (
        <ButtonsContainer>
            <QuickActionsContainer>
                <PostActionButtonsCommentsAndReactions {...props} />
                {pollsOptions && showPollStats && (
                    <PostPollStats
                        postPollOptions={pollsOptions}
                        postId={postId}
                    />
                )}
            </QuickActionsContainer>
        </ButtonsContainer>
    );
}

export function PromoPostActionButtons(props: PostcardActionAttributes) {
    const { postData, pollsOptions, showPollStats = true, postId } = props;

    return (
        <ButtonsContainer>
            {postData?.location && (
                <LocationButton location={postData?.location} />
            )}
            <QuickActionsContainer>
                <PostActionButtonsCommentsAndReactions {...props} />
                {pollsOptions && showPollStats && (
                    <PostPollStats
                        postPollOptions={pollsOptions}
                        postId={postId}
                    />
                )}
            </QuickActionsContainer>
        </ButtonsContainer>
    );
}
